import { render, staticRenderFns } from "./rumpun.vue?vue&type=template&id=7ea7ede5&"
import script from "./rumpun.vue?vue&type=script&lang=js&"
export * from "./rumpun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports